<template>
  <section-layout
    :disabled="!cambiado || loading"
    :loading="loading || saving"
    :showButton="false"
  >
    <template v-slot:title>
      {{localization.tabsTitles.campos}}
    </template>
    <template v-slot:content>
      <v-row align="center" dense class="mt-3">
        <v-col 
          cols="12"
        >
          <v-select
            v-model="camposObligatoriosTraducidos" 
            id="camposObligatoriosTraducidos"
            :items="traduccionCamposIncidencia"
            :label="localization.campos.campos"
            multiple
            chips deletable-chips
            clearable
            hide-details
            color="primary"
            :disabled="saving"
            @change="updateCambiado(true)"
          />
        </v-col>
      </v-row>
    </template>
  </section-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    saving: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    cambiado: {
      type: Boolean,
      default: false
    },
    configuracion: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      camposSeleccionados: [],
      traducciones: {
        eus: {
          'Descripción': 'Deskribapena',
          "Localización": 'Lokalizazioa', 
          "Urgencia": 'Urgentzia', 
          "Oficio": 'Ofizioa', 
          "Suboficio": 'Azpiofizioa', 
          "Predefinida": 'Aurrez definitua', 
          "Parte": 'Partea', 
          "Tipo Reclamación": 'Erreklamazioa', 
          "Responsable": 'Arduraduna', 
          "Fin Previsto": 'Aurreikusitako amaiera'
        },
        eng: {
          'Descripción': 'Description',
          "Localización": 'Location', 
          "Urgencia": 'Urgency', 
          "Oficio": 'Job', 
          "Suboficio": 'Subjob', 
          "Predefinida": 'Predefined', 
          "Parte": 'Part type', 
          "Tipo Reclamación": 'Complaint type', 
          "Responsable": 'Responsible', 
          "Fin Previsto": 'Provided en'
        },
        spa: {
          'Descripción': 'Descripción',
          "Localización": 'Localización', 
          "Urgencia": 'Urgencia', 
          "Oficio": 'Oficio', 
          "Suboficio": 'Suboficio', 
          "Predefinida": 'Predefinida', 
          "Parte": 'Parte', 
          "Tipo Reclamación": 'Tipo Reclamación', 
          "Responsable": 'Responsable', 
          "Fin Previsto": 'Fin Previsto'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      'camposObligatoriosTraducidos': 'camposObligatoriosTraducidos'
    }),
    localization () {
      return this.$t('sectionConfiguracion')
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    traduccionCamposIncidencia() {
      if(this.traducciones[this.usuario.idioma]) {
        return this.configuracion.camposIncidencia.map(x => {
          return this.traducciones[this.usuario.idioma][x] || x
        })
      } else {
        return this.configuracion.camposIncidencia
      }
    },
    camposObligatoriosTraducidos: {
      get(){
        if(this.traducciones[this.usuario.idioma]) {
          return this.configuracion.camposObligatorios.map(x => {
            return this.traducciones[this.usuario.idioma][x] || x
          })
        } else {
          return this.configuracion.camposIncidencia
        }
      },
      set(newValue){
        this.camposSeleccionados = newValue
        return newValue
      } 
    }
  },
  methods: {
    updateCambiado (val) {
      // this.cambiado = val
      let keysSeleccionados = []
      let values = Object.values(this.traducciones[this.usuario.idioma])
      let keys = Object.keys(this.traducciones[this.usuario.idioma])
      values.filter((value, index) => {
        if(this.camposSeleccionados.includes(value)) keysSeleccionados.push(keys[index])
        return (this.camposSeleccionados.includes(value))
      }) 
      this.$emit('cambiado', val)
      this.$emit('actualizarCamposObligatorios', keysSeleccionados)
    },
    mostrarTraduccion(literal) {
      return literal + 'aa'
    }
  },
  watch: {
    cambiado (/* val */) {
      // this.$emit('cambiado', val)
    }
  }
}
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}
</style>